<template>
    <b-form
        :save-url="addUrl"
        @success="formSuccess"
        @failure="formFailure"
        :save-params="{ api_key: currentUser.api_key }"
        v-slot="{ model, loading }"
    >
        <div class="row">
            <validated-input
                class="col-12"
                label="Name"
                v-model="model.name"
                :rules="rules.name"
                :disabled="loading"
            />
        </div>

        <div class="row">
            <validated-input
                class="col-6"
                label="Place"
                v-model="model.place"
                :rules="rules.place"
                :disabled="loading"
            />

            <div class="file-upload-wrapper col-6">
                <label class="field-label">Profile Image</label>

                <div
                    class="custom-file-input"
                    @click="triggerFileInput(loading)"
                >
                    <span>
                        {{
                            fileName ||
                            (model.profile_img
                                ? (model.profile_img.name || model.profile_img.split('/').pop())
                                : 'Browse')
                        }}
                    </span>
                </div>

                <input
                    ref="fileInput"
                    type="file"
                    class="hidden-file-input"
                    accept="image/*"
                    :disabled="loading"
                    @change="handleFileChange($event, model)"
                />
            </div>
        </div>

        <div class="row">
            <div class="col">
                <image-info :width="380" :height="380" />
            </div>
        </div>

        <div class="row">
            <validated-input
                class="col-12"
                label="Comment"
                v-model="model.comment"
                size="150"
                type="text"
                :rules="rules.comment"
                :disabled="loading"
            />
        </div>

        <btn
            class="trn"
            size="sm"
            :loading="loading"
            color="primary"
            text="Save"
            loading-text="Saving..."
            :disabled="loading"
        />
    </b-form>
</template>

<script>
import urls from '../../../../data/urls';
import { mapGetters } from 'vuex';

export default {
    name : 'AddTestimonials',

    computed : {
        ...mapGetters(['currentUser'])
    },

    data () {
        return {
            addUrl : urls.admin.event.testimonials.addEdit,

            fileName : '',

            rules : {
                name : {
                    required : true
                },
                place : {
                    required : true
                },
                profile_img : {
                    required : true
                },
                comment : {
                    required : true,
                    min      : 200,
                    max      : 210
                }
            }
        };
    },

    methods : {
        triggerFileInput (loading) {
            if (!loading) {
                this.$refs.fileInput.click();
            }
        },

        handleFileChange (event, model) {
            const file = event.target.files && event.target.files[0];

            if (!file) {
                return;
            }

            const image = new Image();

            image.onload = () => {
                if (image.width !== 380 || image.height !== 380) {
                    this.$notify(
                        'Please upload an image with dimensions 380 × 380 pixels.',
                        'Invalid Image',
                        {
                            type : 'warning'
                        }
                    );

                    this.fileName = '';
                    model.profile_img = null;
                    this.$refs.fileInput.value = '';

                    URL.revokeObjectURL(image.src);

                    return;
                }

                this.fileName = file.name;
                this.$set(model, 'profile_img', file);

                URL.revokeObjectURL(image.src);
            };

            image.onerror = () => {
                this.fileName = '';
                model.profile_img = null;
                this.$refs.fileInput.value = '';

                this.$notify(
                    'Invalid image file.',
                    'Error',
                    {
                        type : 'warning'
                    }
                );
            };

            image.src = URL.createObjectURL(file);
        },

        formSuccess () {
            this.fileName = '';

            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }

            this.$notify(
                'Successfully Added Testimonial..!',
                'Success',
                {
                    type : 'success'
                }
            );

            this.$emit('success');
        },

        formFailure (response) {
            const json = response.data;

            if (json.permission === false) {
                this.$notify(
                    'Invalid Authentication..!',
                    'Permission Denied',
                    {
                        type : 'warning'
                    }
                );
                return;
            }

            if (json.errors) {
                Object.entries(json.errors).forEach(([field, message]) => {
                    this.$notify(
                        `${field}: ${Array.isArray(message) ? message[0] : message}`,
                        'Validation Error',
                        {
                            type : 'warning'
                        }
                    );
                });

                return;
            }

            this.$notify(
                'Something went wrong!',
                'Error',
                {
                    type : 'error'
                }
            );
        }
    }
};
</script>

<style scoped>
.hidden-file-input {
    display: none;
}

.file-upload-wrapper {
    display: flex;
    flex-direction: column;
}

.field-label {
    margin-bottom: 6px;
    font-size: 14px;
    font-weight: 500;
}

.custom-file-input {
    width: 100%;
    height: 38px;
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    padding: 8px 10px;
    display: flex;
    align-items: center;
    background: #fff;
    cursor: pointer;
    color: #000;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    transition: border-color .2s ease, box-shadow .2s ease;
    overflow: hidden;
}

.custom-file-input:hover {
    border-color: #0d6efd;
}

.custom-file-input span {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
